<div class="spinner-overlay">
  <div class="spinner-container">
    <div class="spinner"></div>
    <p class="loading-text">Chargement...</p>
  </div>
</div>
